import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import { ReactNode } from "react";
import { useSettings } from "../../../../materio/@core/hooks/useSettings";

type Props = {
    children?: ReactNode
}

const ChatWrapper = ({ children }: Props) => {
    const theme = useTheme();
    const { settings } = useSettings()
    const { skin, appBar, footer, layout, navHidden } = settings

    const calculateAppHeight = () => {
        return `(${(appBar === 'hidden' ? 0 : (theme.mixins.toolbar.minHeight as number)) *
            (layout === 'horizontal' && !navHidden ? 2 : 1) +
            (footer === 'hidden' ? 0 : 56)
            }px + ${theme.spacing(6)} * 2)`
    }

    return (
        <div style={{ display: 'flex', width: '100%', flexDirection: 'column', maxHeight: '100%', height: `calc(100vh - ${calculateAppHeight()})`, }}>
            {children}
        </div >
    )
}

export default ChatWrapper;